import { useState } from 'react'

import { Field, Form } from 'formik'
import styled from 'styled-components'

import {
  formFields,
  formFieldsMirvac,
  getFieldLabel,
  getFieldLabelMirvac,
} from 'app/components/Ballot/Disclosures/form.utils'
import BallotHouseholdIncomeModal from 'app/components/Ballot/Modals/BallotHouseholdIncomeModal'
import IncomeTableModalQLD from 'app/components/Ballot/Modals/IncomeTableModalQLD'
import { Box } from 'app/components/design-system-components'
import { Text } from 'app/components/design-system-components/typography'
import { CheckboxInput } from 'app/features/teams/applications/share-applications/ShareApplicationsModal/FormBody'
import { FieldWrapper } from 'app/forms/FieldWrapper'
import theme from 'app/match/applicationReportPDF/assets/theme'
import { QLD_AFFORDABLE_TEAM_NAME } from 'app/utils/text/helpers'

const StyledFieldWrapper = styled(FieldWrapper)`
  line-height: ${theme.lineHeights.encrption};
  margin-bottom: ${theme.space[3]}px;
`

const StyledDisclosureLabel = styled(Text)`
  margin-bottom: 0;
`

export type BallotsHouseholdIncomeLimit = {
  income: number
  rentCap: number
  type: string
}[]

export const FormBody = ({
  ballotsHouseholdIncomeLimit,
  ballotsHouseholdIncomeRegion,
  isMirvac,
  teamSlug = '',
  ballotHouseholdIncomeYear = '',
}: {
  ballotsHouseholdIncomeLimit: BallotsHouseholdIncomeLimit
  ballotsHouseholdIncomeRegion: string
  isMirvac?: boolean
  teamSlug?: string
  ballotHouseholdIncomeYear: string
}) => {
  const [
    isBallotHouseHoldModalIncomeOpened,
    setIsBallotHouseHoldModalIncomeOpened,
  ] = useState<boolean>(false)

  const toggleBallotHouseHoldModalIncome = (
    event: React.MouseEvent<HTMLElement>,
  ) => {
    event.preventDefault()
    setIsBallotHouseHoldModalIncomeOpened(!isBallotHouseHoldModalIncomeOpened)
  }

  const _renderDisclosureCheckbox = (
    disclosureKey: string,
    fieldLabel: string,
  ) => {
    return (
      <StyledFieldWrapper id={disclosureKey} name={disclosureKey}>
        <Field
          name={disclosureKey}
          as={CheckboxInput}
          label={<StyledDisclosureLabel>{fieldLabel}</StyledDisclosureLabel>}
        />
      </StyledFieldWrapper>
    )
  }

  const _formCheckboxes = Object.keys(formFields).map((key) => {
    return _renderDisclosureCheckbox(key, getFieldLabel(key))
  })

  const _formCheckBoxesMirvac = Object.keys(formFieldsMirvac).map((key) => {
    return _renderDisclosureCheckbox(key, getFieldLabelMirvac(key))
  })

  let formChecklist = isMirvac ? _formCheckBoxesMirvac : _formCheckboxes

  let incomeTable = (
    <BallotHouseholdIncomeModal
      ballotsHouseholdIncomeLimit={ballotsHouseholdIncomeLimit}
      toggleBallotHouseHoldModalIncome={toggleBallotHouseHoldModalIncome}
      ballotsHouseholdIncomeRegion={ballotsHouseholdIncomeRegion}
      returnAsComp={true}
    />
  )

  switch (teamSlug) {
    case QLD_AFFORDABLE_TEAM_NAME:
      incomeTable = (
        <IncomeTableModalQLD
          returnAsComp={true}
          ballotsHouseholdIncomeLimit={ballotsHouseholdIncomeLimit}
          ballotHouseholdIncomeYear={ballotHouseholdIncomeYear}
        />
      )
      break
    default:
      break
  }

  return (
    <Box mt={4}>
      <Form>
        {formChecklist}

        <Box mb={0} textAlign="center">
          Table 1: Eligible gross income thresholds
        </Box>
        {incomeTable}
      </Form>
    </Box>
  )
}
